import { render } from "./Information.vue?vue&type=template&id=9001ad2a"
import script from "./Information.vue?vue&type=script&lang=js"
export * from "./Information.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/lf.m2geo.ie/releases/20261103161156/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Organisation/Partials/Information.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9001ad2a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9001ad2a', __exports__)) {
    console.log('reload')
    api.reload('9001ad2a', __exports__)
  }
  
  module.hot.accept("./Information.vue?vue&type=template&id=9001ad2a", () => {
    console.log('re-render')
    api.rerender('9001ad2a', render)
  })

}


export default __exports__